<template>
  <div
    class="maxMaxth home-scrollbar maxMaxth3Dian1"
    :style="{
      'background-image': `url(${config.background_image})`
    }"
  >
    <advertisementHome
      v-if="popList.length"
      @CancelDisplay="CancelDisplay"
      :popList="popList"
      :isShow="isCancelDisplay"
    ></advertisementHome>
    <div>
      <sidebars
        :sidebarsList="sidebarsList"
        :class="{ 'sidebar-hidden': sidebarHidden }"
      >
      </sidebars>
      <sidebarsLeft :sidebarsList="sidebarsLeftList" :class="{ 'sidebaLeft-hidden': sidebarHidden }">
      </sidebarsLeft>
    </div>
    <Header></Header>
    <div
      style="overflow-y: scroll"
      ref="homeScrollbar"
      @scroll="handleScroll"
      :style="{
        height: `calc(100vh - ${$store.state.xiazApp ? 1.6 : 0.9}rem)`
      }"
    >
      <div style="padding-top: 0.2rem">
        <Swipe :swipeList="banner"></Swipe>
      </div>
      <div class="live-box">
        <div class="live-box-item" @click="openUrl('luckyTurntable')">
          <img :src="config.ui38.activity_1" alt="" />
        </div>
        <div class="live-box-item" @click="openUrl('LinkdeConviteEvent')">
          <img :src="config.ui38.activity_2" alt="" />
        </div>
        <div class="live-box-item" @click="openUrl('vip')">
          <img :src="config.ui38.activity_3" alt="" />
        </div>
      </div>
      <div
        style="
          display: flex;
          justify-content: space-around;
          align-items: center;
          padding: 0 0.2rem;
          margin-bottom: 0.2rem;
        "
      >
        <div
          class="notice-bar"
          style="
            background-color: var(--theme-btm-bg-color);
            border-radius: 0.15rem;
            margin-right: 0.2rem;
            height: 0.7rem;
          "
        >
          <van-icon
            style="padding-right: 0.1rem"
            name="volume"
            size="0.4rem"
            color="#fff"
          />
          <van-notice-bar
            class="marquee"
            style="height: 0.5rem"
            :scrollable="true"
          >
            <div style="display: flex; align-items: center">
              <div v-for="item in marquee" v-html="item"></div>
            </div>
          </van-notice-bar>
        </div>
        <div
          style="
            display: flex;
            justify-content: space-around;
            align-items: center;
            width: 0.8rem;
            height: 0.7rem;
            background-color: var(--theme-btm-bg-color);
            border-radius: 0.15rem;
          "
          @click="openUrl('notice', { active: 3 })"
        >
          <van-icon name="chat" size="0.4rem" color="#fff" />
        </div>
      </div>
      <div class="zhtDEqmqr6aOwFvu_UTp" v-if="$store.state.config.show_jackpot">
        <div
          class="_VQdc8vOEOzzyOEUKmvZ"
          :style="`background-position: 0px 0px;background-image: url(${config.jackpot_image});background-size: 100% 100%;`"
        >
          <CountTo
            :startVal="startVal"
            @getDisplayValue="getDisplayValue"
            :endVal="BonusAmount"
            :decimals="2"
            :duration="5000"
          />
          <div
            slot="defaultValue"
            class="defaultValue"
            style="
              margin-top: 0.4rem;
              display: flex;
              align-items: center;
              --jackpot-card-count-box-scale: 0.6;
              transform: scale(var(--jackpot-card-count-box-scale));
            "
          >
            <span
              v-for="(char, index) in getBonusChars(BonusTrendsAmount)"
              :key="index"
              :class="`sprite-font sprite-char-${char}`"
              :style="getSpriteStyle(char)"
              style="display: inline-block; height: 0.83rem"
            >
            </span>
          </div>
        </div>
      </div>

      <ScollIndex
        class="flex items-center"
        style="width: 100%; height: 1.4rem"
        :list="$store.state.allGameList?.platform"
      ></ScollIndex>
      <div class="allgamebox" style="padding: 0.2rem 0.1rem 0.5rem 0.1rem">
        <Gamelist_new
          v-for="(item, index) in $store.state.allGameList?.platform"
          :is_show="item.is_show"
          :key="index"
          :title="item.name"
          :code="item.code"
          :titleImg="item.icon"
          :gamelist="$store.state.allGameList[item.code]"
        ></Gamelist_new>
      </div>
      <div class="footbox">
        <div style="padding: 0 0.2rem" v-if="$store.state.config.show_bets">
          <div
            class="flex justify-center items-center"
            style="
              font-size: 0.25rem;
              padding: 0.15rem 0.3rem;
              color: var(--theme-text-color-lighten);
            "
          >
            <div style="width: 50%">{{ this.$t('_home._Jogos') }}</div>
            <div style="width: 25%; text-align: center">{{ this.$t('_home._jogador') }}</div>
            <div style="width: 25%; text-align: center">{{ this.$t('_home._payout') }}</div>
          </div>
          <div>
            <div
              :class="highlight ? 'lightSingle' : 'lightDouble'"
              v-for="item in $store.state.allBetsList"
              class="flex justify-center items-center"
              style="
                font-size: 0.25rem;
                padding: 0 0.2rem;
                color: #fff;
                padding: 0.15rem 0.3rem;
              "
            >
              <div style="width: 50%">{{ item.gameName }}</div>
              <div style="width: 25%; text-align: center">
                {{ item.userid }}
              </div>
              <div
                style="
                  width: 25%;
                  text-align: center;
                  color: var(--theme-primary-color);
                "
              >
                {{ item.money }}
              </div>
            </div>
          </div>
        </div>
        <div class="vendor-pic">
          <div class="v-p-item">
            <img src="@/assets/icons/3Dian8/PG.webp" alt="" class="top-1 pg" />
          </div>
          <div class="v-p-item">
            <img
              :src="config.ui38.group_logo"
              alt=""
              class="middle-2 logo"
            /><img
              src="@/assets/icons/3Dian8/PP.webp"
              alt=""
              class="left-1 pp"
            /><img
              src="@/assets/icons/3Dian8/CP.webp"
              alt=""
              class="left-2 cp"
            /><img
              src="@/assets/icons/3Dian8/AMBS.webp"
              alt=""
              class="right-1 ambs"
            /><img
              src="@/assets/icons/3Dian8/JDB.webp"
              alt=""
              class="right-2 jdb"
            />
          </div>
          <div class="v-p-item">
            <img
              src="@/assets/icons/3Dian8/TADA.webp"
              alt=""
              class="bottom-3 tada"
            />
          </div>
        </div>
        <div class="flex justify-center items-center">
          <img src="@/assets/icons/3Dian8/share.png" style="width: 0.33rem" />
          <span
            style="
              color: var(--theme-text-color-lighten);
              font-size: 0.21rem;
              font-weight: bold;
              margin-left: 0.1rem;
            "
            >{{ this.$t('_home._Compartilhar') }}</span
          >
        </div>
        <div
          class="flex justify-center items-center"
          style="margin-top: 0.1rem"
        >
          <div
            class="flex justify-center items-center"
            style="
              width: 0.52rem;
              height: 0.52rem;
              border-radius: 50%;
              background: #fff6;
            "
          >
            <img
              src="@/assets/icons/3Dian8/over18.png"
              style="width: 0.52rem"
            />
          </div>
          <div
            class="flex justify-center items-center"
            style="
              margin-left: 0.1rem;
              width: 0.52rem;
              height: 0.52rem;
              border-radius: 50%;
              background: #fff6;
            "
          >
            <img src="@/assets/icons/3Dian8/tg.png" style="width: 0.52rem" />
          </div>
        </div>
        <div
          class="flex justify-between items-center"
          style="padding: 0.5rem 0.1rem 0.3rem 0.1rem"
        >
          <img :src="config?.home_logo" alt="" style="width: 3rem" />
          <div
            @click.stop="$store.commit('publicFun', ['AppDownload', true])"
            style="
              font-size: 0.21rem;
              background-color: rgb(var(--theme-ant-primary-color-19));
              padding: 0.1rem;
              border-radius: 0.1rem;
              cursor: pointer;
              color: var(--theme-primary-font-color);
            "
          >
            {{ $t('_home._BaixarAgora') }}
          </div>
        </div>
        <div class="company-info">
          <div v-html="$store.state.config.explain_description"></div>
        </div>
        <div class="ZvyDsn48oSuCoga63jmJ copy-right">
          <div
            class="ZvyDsn48oSuCoga63jmJ"
            style="font-size: 0.18rem; text-align: center"
          >
            <ul>
              <li>
                <div
                  style="font-size: 0.18rem"
                  v-html="
                    $store.state.config.project_name +
                    $store.state.config.copyright
                  "
                ></div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <van-popup
      position="left"
      v-model="$store.state.showPopup"
      style="height: 100dvh; width: 5rem; position: fixed; left: 0 !important"
    >
      <div
        style="
          width: 100%;
          height: 100%;
          background-position: center;
          background-size: 100% 100%;
          flex-direction: column;
          color: #fff;
          overflow: hidden;
          position: relative;
        "
        :style="{ backgroundImage: `url(${config.ui38.side_nav_bg})` }"
      >
        <div
          class="flex justify-between items-center"
          style="padding: 0.2rem; background: rgba(0, 0, 0, 0.1)"
        >
          <img
            src="../../assets/icons/3Dian8/goBack.png"
            style="height: 0.5rem; cursor: pointer"
            @click="$store.state.showPopup = false"
          />
          <img :src="config?.home_logo" alt="" style="height: 0.3rem" />
        </div>
        <div
          v-if="vuex_token_head"
          style="
            background: #ffffff14;
            border-radius: 0.18rem;
            padding: 0.2rem;
            font-size: 0.18rem;
            margin: 0.2rem;
          "
        >
          <div class="flex items-center">
            <img
              :src="config.user_avatar_image"
              style="width: 0.6rem; height: 0.6rem; border-radius: 50%"
            />
            <div
              class="zvrVqQuEWSzu7Nsavegl flex item-center justify-center"
              style="margin-left: 0.2rem; flex-direction: column"
            >
              <span class="NeL_d0h5i7Kr9xdDCTty"
                ><span class="B8Z5jNPFB44UUahGOFBH EpCtJEz_E_WMlMB6HeaI"
                  >{{ $t('mine._Conta') }}:</span
                ><span class="PIj1PfbzHvacLB3SeEjQ">{{
                  userInfo.user_name
                }}</span></span
              >
              <div
                class="Fn6L7w5ZEXiwo2fTNrRn flex item-center"
                style="margin-top: 0.1rem"
              >
                <div class="glbY5bkp9x7KTYOGrdBC flex items-center" style="">
                  <span class="B8Z5jNPFB44UUahGOFBH EpCtJEz_E_WMlMB6HeaI"
                    >ID:</span
                  ><span class="PIj1PfbzHvacLB3SeEjQ">{{ userInfo.id }}</span>
                  <div
                    @click="copyContent(userInfo.id)"
                    class="blXLPejbalUrq5IycYVR wJ30VxmrZK3Y5gTd1Zq0 kot86ytTGgQsl2K_lpQ5"
                    style="width: 0.2rem; height: 0.2rem; margin-left: 0.05rem"
                  >
                    <svg-icon
                      className="imageWrap"
                      style="cursor: pointer; width: 0.2rem; height: 0.2rem"
                      icon-class="style_1_icon_copy--svgSprite:all"
                    />
                  </div>
                </div>
                <span class="DTiaFYH2mnNOHXa8KLF0"></span>
              </div>
            </div>
          </div>
          <div
            style="
              font-weight: bold;
              font-size: 16px;
              color: #fedc83;
              padding: 0.1rem 0;
            "
          >
            {{ userBalance }}
            <span style="margin-left: 0.05rem">{{ $store.state.config.currency }}</span>
          </div>
          <div class="flex items-center" style="gap: 0.1rem">
            <div
              class="flex justify-center items-center"
              style="
                width: 50%;
                height: 0.5rem;
                font-size: 0.21rem;
                font-weight: bold;
                background: var(--theme-primary-color);
                color: var(--theme-primary-font-color);
                border-radius: 0.1rem;
                cursor: pointer;
              "
              @click="
                $store.commit('isDeposit', true),
                  ($store.state.showPopup = false)
              "
            >
              <svg-icon
                style="margin-right: 0.06rem"
                className="imageNav"
                icon-class="style_1_icon_mid_cz--svgSprite:all"
              />
              {{ $t('mine._Depósito') }}
            </div>
            <div
              class="flex justify-center items-center"
              style="
                width: 50%;
                height: 0.5rem;
                font-size: 0.21rem;
                font-weight: bold;
                background: hsla(0, 0%, 100%, 0.4);
                color: #fff;
                border-radius: 0.1rem;
                cursor: pointer;
              "
              @click="
                openUrl(
                  userInfo.set_withdraw_password ? 'withdraw' : 'security'
                )
              "
            >
              <img
                src="@/assets/icons/3Dian8/Saque.webp"
                style="width: 0.3rem; margin-right: 0.06rem"
              />{{ $t('mine._Saque') }}
            </div>
          </div>
        </div>
        <div
          v-else
          style="
            background: #ffffff14;
            border-radius: 0.18rem;
            padding: 0.2rem;
            font-size: 0.18rem;
            margin: 0.2rem;
          "
        >
          <div class="crcd82r1PVsQivOcCftk">
            <van-button
              @click="
                $store.commit('isRecord'),
                  $store.commit('publicFun', ['isRecordType', 1]),
                  ($store.state.showPopup = false)
              "
              type="primary"
              size="mini"
              >{{ $t('Login._Login') }}</van-button
            >
            <van-button
              @click="
                $store.commit('isRecord'),
                  $store.commit('publicFun', ['isRecordType', 0]),
                  ($store.state.showPopup = false)
              "
              type="default"
              size="mini"
            >
              {{ $t('Login._Registro') }}
            </van-button>
          </div>
        </div>
        <div class="menuGrid" style="font-size: 0.2rem">
          <el-row :gutter="20">
            <el-col
              :span="8"
              style="margin-top: 0.2rem; cursor: pointer"
              v-for="item in menuGridList"
              :key="item.title"
            >
              <div
                class="flex justify-center items-center"
                style="flex-direction: column"
                @click="openUrl(item.jump_url)"
              >
                <img
                  :src="item.icon"
                  style="
                    width: 0.8rem;
                    background-color: var(--theme-home-bg);
                    border-radius: 0.1rem;
                  "
                />
                <span>{{ item.title }}</span>
              </div>
            </el-col>
          </el-row>
        </div>
        <div
          style="
            position: absolute;
            bottom: 0rem;
            left: 0;
            right: 0;
            margin: 0 auto;
            width: calc(100% - 0.4rem);
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            background: rgba(0, 0, 0, 0.2);
            padding: 0.2rem;
          "
        >
          <div
            class="flex justify-center items-center"
            style="
              width: 100%;
              margin-bottom: 0.2rem;
              border-radius: 0.15rem;
              overflow: hidden;
            "
            :style="{
              //background: boxBg
            }"
            @click="openUrl('notice')"
          >
            <img
              src="@/assets/icons/3Dian8/go_server.png"
              style="width: 100%"
            />
          </div>
          <div
            class="flex justify-center items-center"
            style="
              width: 100%;
              position: relative;
              border-radius: 0.15rem;
              overflow: hidden;
            "
            :style="{
              //background: boxBg
            }"
          >
            <img
              src="@/assets/icons/3Dian8/drawer_bottom_bg.png"
              style="width: 100%"
            />
            <img
              src="@/assets/icons/3Dian8/over18.png"
              style="
                width: 0.52rem;
                position: absolute;
                left: 22.5%;
                bottom: 35%;
              "
            />
            <img
              src="@/assets/icons/3Dian8/tg.png"
              style="
                width: 0.52rem;
                position: absolute;
                right: 22.5%;
                bottom: 35%;
              "
            />
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
// @ is an alias to /src
import ScollIndex from '../Scroll/index.vue';
import Gamelist_new from '../gameList-box/index.vue';
import Sidebar from '@/components/sidebar/index.vue';
import Swipe from '@/components/swipe/index.vue';
import {
  ICON_NAV,
  ICON_NAVActive,
  ICON_NAV3Dian1,
  ICON_NAVActiveDian1
} from '@/assets/public/icon_nav.js';
import Overlay from '@/components/audio/overlay.vue';
import gameItem from '@/components/gameItem/index.vue';
import CountTo from '@/components/vue-count-to/vue-countTo.vue';
import advertisementHome from '@/components/advertisement/home.vue';
import sidebars from '@/components/sidebars/index.vue';
import sidebarsLeft from '@/components/sidebars/index-left.vue';
import { mapState } from 'vuex';
let time;
import Vue from 'vue';
import {
  popAndBanner,
  notification,
  jackpot,
  getAllGameCategory,
  getDataByGameCategory
} from '@/apis/modules/home.js';
export default {
  name: 'Home',
  components: {
    Sidebar,
    sidebarsLeft,
    Swipe,
    Overlay,
    sidebars,
    CountTo,
    gameItem,
    advertisementHome,
    ScollIndex,
    Gamelist_new
  },
  computed: {
    ...mapState([
      'first_recharge',
      'popList',
      'tabNav',
      'banner',
      'sidebarsList',
      'sidebarsLeftList',
      'marquee',
      'config',
      'isCancelDisplay',
      'vuex_token_head'
    ]),
    userInfo() {
      if (this.$store.state.userInfo && this.$store.state.userInfo.vip_info) {
        return this.$store.state.userInfo;
      } else {
        return { vip_info: {} };
      }
    },
    moneyInfo() {
      return this.$store.state.moneyInfo;
    },
    allGameList() {
      return this.$store.state.allGameList;
    }
  },
  data() {
    return {
      highlight: true,
      boxBg: 'linear-gradient(180deg, #42352f, #000)',
      menuGridList: [
        {
          title: this.$t('_home._Checkin'),
          icon: require('../../assets/icons/3Dian8/icon2.png'),
          jump_url: 'dailySignIn'
        },
        {
          title: this.$t('_home._Sorteio'),
          icon: require('../../assets/icons/3Dian8/icon6.png'),
          jump_url: 'luckyTurntable'
        },
        {
          title: this.$t('_home._Convidar'),
          icon: require('../../assets/icons/3Dian8/icon9.png'),
          jump_url: 'promote'
        },
        {
          title: this.$t('_home._VIP'),
          icon: require('../../assets/icons/3Dian8/icon10.png'),
          jump_url: 'vip'
        }
      ],
      userBalance: 0,
      tongzhi: require('../../assets/icons/images/icon_dt_pmd.png'),
      coloImgactivity: require('../../assets/icons/images/1795312712372871170.gif'),
      startVal: 0,
      iconList: [],
      stateActive: true,
      widUrl: window.location.href,
      activeList: ICON_NAVActiveDian1,
      base_Config: {},
      BonusAmount: '',
      BonusTrendsAmount: '',
      recentJson: {},
      favoriteJson: {},
      thisiTime: '',
      tabState: false,
      vuex_tokenIs: false,
      scrollDom: '',
      isTabsShow: false,
      tabForm: {
        leftRight: 0
      },
      topNavList: this.$store.state.config.top_nav_list,
      // 精灵图字符映射
      spriteCharMap: {
        0: { x: 0, y: 0, width: 0.5 },
        1: { x: -0.5, y: 0, width: 0.5 },
        2: { x: -1.05, y: 0, width: 0.5 },
        3: { x: -1.52, y: 0, width: 0.5 },
        4: { x: -2.05, y: 0, width: 0.5 },
        5: { x: -2.55, y: 0, width: 0.5 },
        6: { x: -3.05, y: 0, width: 0.5 },
        7: { x: -3.55, y: 0, width: 0.5 },
        8: { x: -4.08, y: 0, width: 0.5 },
        9: { x: -4.55, y: 0, width: 0.5 },
        '.': { x: -5.05, y: 0, width: 0.3 },
        ',': { x: -5.35, y: 0, width: 0.3 }
      },
      // Sidebar滚动隐藏相关状态
      sidebarHidden: false,
      scrollTimer: null,
      lastScrollTime: 0,
      popularlist: [],
      betsListNum: 10
    };
  },
  created() {
    this.userBalance = this.$store.state.config.balance_no_bonus.includes(
      'user_center'
    )
      ? this.moneyInfo.balance_coin_str
      : this.moneyInfo.balance_total_str;
    this.inviteFun();
    // 添加集团信息
    if (this.$store.state.config.group_info && !ICON_NAV3Dian1[7]) {
      ICON_NAV3Dian1.push({
        name: this.$store.state.config.group_info.name,
        svg: '',
        textName: this.$store.state.config.group_info.name
      });
      ICON_NAVActiveDian1.push(this.$store.state.config.group_info.icon);
      this.$t('popup.nav_31').push({
        title: this.$store.state.config.group_info.name,
        type: 'gorup'
      });
    }

    // 鱼在前面
    if (
      this.$store.state.config.fish_first &&
      ICON_NAV3Dian1[2].name != 'piscator'
    ) {
      [ICON_NAV3Dian1[2], ICON_NAV3Dian1[3]] = [
        ICON_NAV3Dian1[3],
        ICON_NAV3Dian1[2]
      ];
      [ICON_NAVActiveDian1[2], ICON_NAVActiveDian1[3]] = [
        ICON_NAVActiveDian1[3],
        ICON_NAVActiveDian1[2]
      ];
      [this.$t('popup.nav_31')[2], this.$t('popup.nav_31')[3]] = [
        this.$t('popup.nav_31')[3],
        this.$t('popup.nav_31')[2]
      ];
    }

    if (this._vuex_token && typeof this._vuex_token() == 'string') {
      this.getBalance();
      this.vuex_tokenIs = true;
      let demoIndex = 0;
      this.iconList = ICON_NAV3Dian1.filter((item, index) => {
        if (item.textName == '_Demo') demoIndex = index;
        return item.textName != '_Demo';
      });
      this.activeList = ICON_NAVActiveDian1.filter((item, index) => {
        return index != demoIndex;
      });
      if (this.$t('popup.nav_31')[demoIndex].title == 'Demo') {
        this.$t('popup.nav_31').splice(demoIndex, 1);
      }
    } else {
      this.iconList = ICON_NAV3Dian1;
    }
    this.getpopAndBanner();
    this.getNotification();
    this.getAllGameCategory();
    this.showRegisterPage();
  },
  watch: {
    // 监听message数据的变化
    allGameList(newValue, oldValue) {
      this.popularlist = newValue.popular;
      for (let index = 0; index < 10; index++) {
        const obj = {
          gameName: this.popularlist[index].name,
          userid:
            '****' +
            String(Math.floor(Math.random() * 10)) +
            String(Math.floor(Math.random() * 10)) +
            String(Math.floor(Math.random() * 10)),
          money: this.formatCurrency(Math.floor(Math.random() * (5000 - 200 + 1)) + 200,'',0)
        };
        this.$store.state.allBetsList.push(obj);
      }
      this.changehighlight();
    }
  },
  mounted() {
    Vue.prototype.homeScrollbarDom = this.$refs.homeScrollbar;
    this.$nextTick(() => {
      let el = this.$refs.navTbaSwConte.$el;
      let scrollDom = el.getElementsByClassName('van-tabs__nav')[0];
      this.scrollDom = scrollDom;
      let offsetWidth = scrollDom.offsetWidth;
      let scrollWidth = scrollDom.scrollWidth;
      let scrollJisuan = scrollWidth - offsetWidth;
      let { leftRight } = this.tabForm;
      scrollDom.addEventListener('scroll', e => {
        if (scrollJisuan <= scrollDom.scrollLeft) {
          this.tabForm.leftRight = 1;
        } else if (scrollDom.scrollLeft == 0) {
          this.tabForm.leftRight = 0;
        } else if (leftRight != 2 && scrollDom.scrollLeft != 0) {
          this.tabForm.leftRight = 2;
        }
      });
    });
    this.getjackpot(0);
  },
  beforeDestroy() {
    clearTimeout(this.thisiTime);
  },
  methods: {
    changehighlight() {
      setTimeout(() => {
        this.highlight = !this.highlight;
        this.$store.state.allBetsList.pop();
        const obj = {
          gameName: this.popularlist[this.betsListNum].name,
          userid:
            '****' +
            String(Math.floor(Math.random() * 10)) +
            String(Math.floor(Math.random() * 10)) +
            String(Math.floor(Math.random() * 10)),
          money: this.formatCurrency(Math.floor(Math.random() * (5000 - 200 + 1)) + 200,'',0)
        };
        this.$store.state.allBetsList.unshift(obj);
        this.betsListNum++;
        if (this.betsListNum >= this.popularlist.length) {
          this.betsListNum = 0;
        }
        this.changehighlight();
      }, 1500);
    },
    openUrl(e, a) {
      this.$store.state.showPopup = false;

      // 需要先登录
      if (['luckyTurntable','LinkdeConviteEvent','vip'].includes(e) && !this.vuex_token_head) {
        let rememberPassword = window.localStorage.getItem('rememberPassword');
        if (rememberPassword && rememberPassword.length) {
          this.$store.commit('isRecord');
          this.$store.commit('publicFun', ['isRecordType', 1]);
        } else {
          this.$store.commit('isRecord');
          this.$store.commit('publicFun', ['isRecordType', 0]);
        }
        return false;
      }

      if (e == 'dailySignIn') {
        this.$store.commit('publicFun', ['CancelIsSigned_days', true]);
        return false;
      }
      if (a) {
        this.$router.push({
          name: e,
          query: {
            ...a
          }
        });
      } else {
        this.$router.push({ name: e });
      }
    },
    doJump(item) {
      if (item.jump_url && item.jump_url != '#') {
        if (/^http/.test(item.jump_url)) {
          window.open(item.jump_url, '_blank');
          return false;
        }
        if (item.jump_url == '#register') {
          if (!this.vuex_token_head) {
            let rememberPassword = window.localStorage.getItem('rememberPassword');
            if (rememberPassword && rememberPassword.length) {
              this.$store.commit('isRecord');
              this.$store.commit('publicFun', ['isRecordType', 1]);
            } else {
              this.$store.commit('isRecord');
              this.$store.commit('publicFun', ['isRecordType', 0]);
            }
            return false;
          }
          return false;
        }
        this.$router.push({ name: item.jump_url });
      }
    },
    // 精灵图字体相关方法
    getBonusChars(amount) {
      // 将数字转换为字符数组
      return String(amount || '0').split('');
    },
    getSpriteStyle(char) {
      const pos = this.spriteCharMap[char];
      if (pos) {
        return {
          backgroundPosition: `${pos.x}rem ${pos.y}rem`,
          width: `${pos.width}rem`,
          backgroundImage: `url(${require('@/assets/cjc1_style_' +
            this.$store.state.config.jackpot_number_img +
            '_font_sprite.webp')})`,
          backgroundSize: 'auto 100%',
          backgroundRepeat: 'no-repeat'
        };
      }
      return {
        backgroundImage: `url(${require('@/assets/cjc1_style_6_font_sprite.webp')})`,
        backgroundSize: 'auto 100%',
        backgroundRepeat: 'no-repeat',
        width: '0.5rem'
      };
    },
    subgame(name) {
      //console.log(name);
      if (name == 'slots') {
        name = 'slot';
      }
      this.$router.push({
        name: 'subgame',
        query: {
          category: name,
          platformValue: 'popular'
        }
      });
      // piscator
    },
    CancelDisplay(e) {
      this.$store.commit('publicFun', ['isCancelDisplay', false]);
      if (this.$store.state.isRefreshLoading) {
        setTimeout(() => {
          let isRechargeGiftTime = localStorage.getItem('isRechargeGiftTime');
          let isRechargeGift = localStorage.getItem('isRechargeGift');
          if (isRechargeGiftTime && isRechargeGift !== 'false') {
            if (isRechargeGiftTime < new Date().getTime()) {
              this.$store.commit('publicFun', ['isCancelDisplay', true]);
              return;
            }
          }
          if (!isRechargeGift && !isRechargeGiftTime) {
            if (this.first_recharge.status == 'show') {
              this.$store.commit('publicFun', ['isRechargeGift', true]);
              return;
            }
          }
        }, 500);
        this.$store.commit('publicFun', ['isRefreshLoading', false]);
      }
    },
    showRegisterPage() {
      if (this.vuex_tokenIs || !this.$store.state.config.register_page_pop)
        return;
      this.$store.commit('isRecord');
      this.$store.commit('publicFun', ['isRecordType', 0]);
    },
    inviteFun() {
      let { id, type } = this.$route.query;
      //console.log(this.$route.query,id,type,'inviteID 22')
      if (id) {
        window.localStorage.setItem('inviteID', id);
      }
      // this.$store.commit('isRecord')
      // this.$store.commit('publicFun',['isRecordType',0])
    },
    navTbaSw(e) {
      if (e == 'right') {
        this.scrollDom.scrollLeft = 1000;
      }
      if (e == 'left') {
        this.scrollDom.scrollLeft = 0;
      }
    },
    beforeChange(name, title) {
      //
    },
    scrollTabs(e) {},
    handleScroll(e) {
      // 记录当前滚动时间
      this.lastScrollTime = Date.now();

      // 滚动时隐藏Sidebar
      if (!this.sidebarHidden) {
        this.sidebarHidden = true;
      }

      // 清除之前的定时器
      if (this.scrollTimer) {
        clearTimeout(this.scrollTimer);
      }

      // 设置新的定时器，2秒后显示Sidebar
      this.scrollTimer = setTimeout(() => {
        this.sidebarHidden = false;
      }, 1500);

      clearTimeout(time);
      time = setTimeout(() => {
        clearTimeout(time);
        if (e.target.scrollTop > e.target.offsetHeight / 3 + 59) {
          this.$store.commit('publicFun', ['Returntotop', true]);
        } else if (this.$store.state.Returntotop) {
          this.$store.commit('publicFun', ['Returntotop', false]);
        }
        if (
          e.target.scrollTop >
          e.target.scrollHeight - e.target.offsetHeight - 20
        ) {
          this.isTabsShow = true;
        } else {
          this.isTabsShow = false;
        }
      }, 10);
    },
    isDisabled(index) {
      let isTrue = false;
      let active = this.$store.state.active;
      if (index == 3) {
        isTrue = true;
        return true;
      }
      if (active < 3) {
        if (index < 3) {
          return false;
        }
        if (index > 3) {
          isTrue = false;
          return true;
        }
      }
      if (active > 3) {
        if (index < 3) {
          isTrue = true;
          return true;
        }
        if (index > 3) {
          isTrue = false;
          return false;
        }
      }
      return isTrue;
    },
    getAllGameCategory() {
      if (this.tabNav.popular) {
        return false;
      }
      getAllGameCategory({}).then(({ code, data = {}, msg }) => {
        this.$store.commit('publicFun', ['tabNav', data]);
      });
    },
    goToNewPage(url) {
      if (url == '#') {
        return false;
      }
      window.open(url, '_blank');
    },
    congxJiazai(category, _key_) {
      let pageSize =
        category == 'popular' && this.$store.state.config.popular_page_size
          ? this.$store.state.config.popular_page_size
          : 6;
      let page = this.tabNav[category]
        ? this.tabNav[category].now / pageSize + 1
        : 1;
      //console.log(_key_)
      if (_key_) {
        page = this[_key_ + 'Json'].now
          ? this[_key_ + 'Json'].now / pageSize + 1
          : 1;
      }
      getDataByGameCategory({
        category: category,
        page: page
      }).then(({ code, data = {}, msg }) => {
        if (!_key_) {
          this.tabNav[category] = {
            ...this.tabNav[category],
            now: data.now,
            list: [...this.tabNav[category].list, ...data.list]
          };
          this.$store.commit('publicFun', ['tabNav', this.tabNav]);
        } else {
          let listz = this[_key_ + 'Json'].list
            ? [...this[_key_ + 'Json'].list, ...data.list]
            : [...data.list];
          this[_key_ + 'Json'] = {
            ...this[_key_ + 'Json'],
            now: data.now,
            list: listz
          };
        }
      });
    },
    getDisplayValue(value) {
      this.BonusTrendsAmount = value;
    },
    getpopAndBanner() {
      //
      if (this.banner.length) {
        return false;
      }
      popAndBanner({}).then(({ code, data = {}, msg }) => {
        let { banner, pop, sidebars, first_recharge } = data;
        this.$store.commit('publicFun', ['banner', banner]);
        this.$store.commit('publicFun', ['first_recharge', first_recharge]);
        // this.banner = banner;
        if (!this.popList.length) {
          this.$store.commit(
            'popList',
            pop.map(item => {
              return {
                ...item,
                isShow: true
              };
            })
          );
        }
        this.$store.commit('publicFun', ['sidebarsList', sidebars.right.map((item) => {
					return {...item,isShow: true};
        })]);
				this.$store.commit('publicFun', ['sidebarsLeftList', sidebars.left.map((item) => {
          return {...item,isShow: true};
        })]);
      });
    },

    getNotification() {
      if (this.marquee) {
        return false;
      }
      notification({}).then(({ code, data, msg }) => {
        //404
        let { marquee } = data;
        this.$store.commit('publicFun', ['marquee', marquee]);
      });
    },
    getjackpot(tim, _false) {
      if (!this.$store.state.config.show_jackpot) return;
      // if(_false){return false}
      clearTimeout(this.thisiTime);
      this.thisiTime = setTimeout(() => {
        jackpot({
          isLOgin: true
        }).then(({ code, data, msg }) => {
          this.startVal = data - 1999 || 0;
          this.BonusAmount = data || 0;
        });
        if (this.$route.name == 'home') {
          this.getjackpot(10000);
        }
        let { code, category } = this.$route.query;
      }, tim);
    },
    onClickDisabled(e) {
      this.$router.push({
        name: 'subgame',
        query: {
          id: '',
          category: 'demo'
        }
      });
    },
    tabFun(e, title) {
      if (e == 7 && this.$store.state.config.group_info) {
        window.open(this.$store.state.config.group_info.jump, '_blank');
        return;
      }
      if (e < 4) {
        this.stateActive = true;
      } else {
        this.stateActive = false;
      }
      let category = this.iconList[e].name;
      if (category == 'recent') {
        this.congxJiazai(category, category);
        this[category + 'Json'] = {};
      }
      if (category == 'favorite') {
        this.congxJiazai(category, category);
        this[category + 'Json'] = {};
      }
      setTimeout(() => {
        this.$store.commit('active', e);
      }, 1000);
    },
    stickyScroLL(e) {}
  }
};
</script>
<style scoped>
.lightSingle:nth-child(odd) {
  border-radius: 0.15rem;
  background-color: var(--theme-text-color-lighten);
}
.lightDouble:nth-child(even) {
  border-radius: 0.15rem;
  background-color: var(--theme-text-color-lighten);
}
.crcd82r1PVsQivOcCftk {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.crcd82r1PVsQivOcCftk button {
  height: 0.51rem;
  font-size: 0.22rem;
  min-width: 2rem;
  padding: 0 0.1rem;
  border-radius: 0.1rem;
}
.footbox {
  width: 100%;
  background: var(--theme-btm-bg-color);
  padding-top: 0.1rem;
  padding-bottom: 1.5rem;

  .vendor-pic {
    width: 100%;
    height: 4.5rem;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 0 0.5rem;
    box-sizing: border-box;
    margin: 1rem auto;

    .v-p-item {
      width: 33.33%;
      height: -webkit-fit-content;
      height: fit-content;
      position: relative;

      img {
        width: 100%;
        height: auto;
      }

      .left-1 {
        position: absolute;
        right: 100%;
        top: 0;
        transform: translateY(-50%);
      }

      .left-2 {
        position: absolute;
        right: 100%;
        top: 100%;
        transform: translateY(-50%);
      }

      .right-1 {
        position: absolute;
        left: 100%;
        top: 0;
        transform: translateY(-50%);
      }

      .right-2 {
        position: absolute;
        left: 100%;
        top: 100%;
        transform: translateY(-50%);
      }
    }
  }
}

.live-box {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0 0.1rem;

  .live-box-item {
    width: 31%;
    img {
      width: 100%;
    }
  }
}

.swiper-box {
  padding: 0rem 0.2rem 0.2rem;
}

:deep(.van-grid-item__content) {
  background-color: transparent !important;
}

/* // isTabsShow van-sticky van-sticky--fixed */

.tabs .imageWrap {
  margin-left: -0.1rem;
}

.imageWrap_s {
  margin-left: 0.05rem;
}

.leftButton,
.rightButton {
  background-color: rgba(0, 0, 0, 0.1);
  border: 0.01rem solid hsla(0, 0%, 100%, 0.1);
  border-radius: 0.18rem;
  color: #fff;
  cursor: pointer;
  height: 0.36rem;
  line-height: 0.36rem;
  text-align: center;
  top: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  width: 0.36rem;
  min-width: 0.36rem;
}

.leftButton svg,
.rightButton svg {
  width: 0.18rem;
  height: 0.18rem;
}

.tabForm-box {
  width: 100%;
  height: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  top: 0.55rem;
  z-index: 10;
}

.h5MidMenuTab {
  padding: 0 0.092rem !important;
}

.leftButton {
  position: absolute;
  left: 0;
  transform: translateY(-50%) rotate(180deg);
}

.tabs .van-tabs__content {
  position: relative;
}

.rightButton {
  position: absolute;
  right: 0;
}
/* 	.maxMaxth3Dian1 .van-sticky.van-sticky--fixed {
		position: initial;
		transition: .5s;
	} */
.maxMaxth3Dian1 .van-tabs__wrap--scrollable .van-tab {
  padding: 0;
}

.maxMaxth3Dian1 .tabs .van-tabs .van-tabs__nav {
  background-color: transparent;
  border-bottom: 0.01rem solid var(--theme-color-line);
  height: 1.06rem;
  overflow: scroll;
  padding: 0.08rem 0 0;
  position: initial;
}

.isTabsShow .van-sticky {
  opacity: 0;
}

.van-sticky.van-sticky--fixed {
  transform: initial;
  transition: 0.5s;
}

.conter_box .van-tab--disabled {
  color: #646566 !important;
  cursor: pointer;
}

.conter_box .van-tab {
  padding: 0;
}

.home-scrollbar .van-tab__text--ellipsis {
  -webkit-line-clamp: initial;
}

.home-scrollbar .van-sticky--fixed {
  z-index: 88;
}

.home-scrollbar {
  height: 100vh;
  /* overflow: scroll; */
}

.conterTeng-scrollbar::-webkit-scrollbar {
  width: 0rem;
  height: 1rem;
  display: block;
  position: relative;
}

/* 自定义滚动条轨道 */
.conterTeng-scrollbar::-webkit-scrollbar-track {
  background: transparent;
  /* 设置轨道的背景颜色 */
}

/* 自定义滚动条的滑块（thumb） */
.conterTeng-scrollbar::-webkit-scrollbar-thumb {
  background: var(--theme-color-line);
  /* 设置滑块的背景颜色 */
}

/* 当滑块悬停或活动时自定义滚动条的滑块 */
.conterTeng-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #555;
  /* 设置滑块在悬停状态下的背景颜色 */
}

.conterTeng-scrollbar {
  -ms-overflow-style: scroll;
  /* 针对IE、Edge浏览器 */
  /* scrollbar-width: auto; 针对Firefox浏览器 */
}

.marquee {
  border-radius: 0;
  font-size: 0.24rem !important;
  padding: 0 0.2rem 0 0.25rem;
  -ms-flex-align: center;
  -ms-flex-pack: justify;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0) !important;
  color: var(--theme-text-color) !important;
  display: -ms-flexbox;
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0 !important;
}

.van-hairline--bottom::after {
  border: none !important;
}

.marquee .van-icon {
  display: flex;
  justify-content: center;
  align-content: center;
  margin-right: 5px;
}

.notice-bar {
  display: flex;
  width: 100%;
  align-items: center;
  box-sizing: border-box;
  padding: 0.1rem !important;
  cursor: pointer;
}

.zhtDEqmqr6aOwFvu_UTp {
  padding: 0 0.1rem;
  margin-bottom: 0.2rem;
  align-items: center;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  justify-content: center;
}

._VQdc8vOEOzzyOEUKmvZ {
  cursor: pointer;
  height: var(--jackpot-card-height);
  margin: 0;
  position: relative;
  width: var(--jackpot-card-width);
  display: flex;
  align-items: center;
  justify-content: center;
}

.defaultValue {
  justify-content: center;
}

.tabs {
  height: 100%;
}

.vwuYKuCNAmUF0GsyJhVu {
  padding: 0 0.2rem;
}

.gameItemBox {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  height: 100%;
}

.scroll-container {
  height: 100%;
  overflow: auto;
}

.tabs .van-tab {
  line-height: normal;
}

.tabs .van-tabs--line .van-tabs__wrap {
  height: auto !important;
}

.tabs .van-tabs .van-tabs__nav {
  background-color: var(--theme-home-bg);
  border-bottom: 0.01rem solid var(--theme-color-line);
  height: 1.06rem;
  padding: 0.08rem 0 0;
}

.tabs .van-tabs__line {
  background-color: var(--theme-primary-color);
  border-radius: 0.04rem 0.04rem 0 0;
  height: 0.04rem;
  min-width: 1.5rem;
  bottom: 0;
}

.maxMaxth3Dian1 .tabs .van-tab--active .h5MidMenuTab {
  color: var(--theme-alt-neutral-2) !important;
}

.maxMaxth3Dian1 .tabs .van-tabs__line {
  background-color: transparent !important;
}

.tabs .cover {
  background: transparent !important;
}

.tabs .imageWrap {
  height: 0.46rem !important;
  width: 0.6rem !important;
}

.h5MidMenuTab {
  min-width: 1.5rem;
  position: relative;
  text-align: center;
  z-index: 2;
  color: var(--theme-alt-neutral-2);
}

.game-category-name {
  line-height: 1.5;
  max-width: 1.36rem;
  width: 1.36rem !important;
}

.leftTitle {
  -ms-flex-align: center;
  align-items: center;
  color: var(--theme-text-color-darken);
  display: -ms-flexbox;
  display: flex;
  font-size: 0.3rem;
}

.rightTitle {
  margin: -0.12rem -0.2rem;
  padding: 0.12rem 0.2rem;
  color: var(--theme-text-color-lighten);
  cursor: pointer;
  font-size: 0.24rem;
}

.kQtvRRirB33JTKwlSb26 {
  -ms-flex-align: center;
  -ms-flex-pack: justify;
  align-items: center;
  display: -ms-flexbox;
  display: flex;
  justify-content: space-between;
  padding: 0.3rem 0;
}

.bkAYznjEc9hUqGQh_a3S {
  display: block;
  font-size: 0.24rem;
  text-align: center;
  color: var(--theme-text-color-lighten);
  margin-top: 0.1rem;
  margin-bottom: 0.2rem;
}

.WGAruokZzpTWkHI2SQ9G {
  color: var(--theme-text-color);
  display: block;
  font-size: 0.24rem;
  margin-top: 0.03rem;
}

.LseXQWJMvDiV2XalL3sA {
  padding: 0.4rem 0.2rem;
  position: relative;
  width: 100%;
  background-color: var(--theme-btm-bg-color);
  z-index: 1;
  box-sizing: border-box;
}

.UJY0E549iXw8BAops2og {
  -ms-flex: 1;
  flex: 1;
  overflow: hidden;
}

.vertival-box {
  margin-bottom: 0;
  padding-bottom: 0;
  position: initial;
}

.vertival-box > div {
  padding-right: 0.2rem;
}

.UJY0E549iXw8BAops2og .JxE2bCrlce_jVHNQ56UL {
  color: var(--theme-text-color-lighten);
  font-size: 0.26rem;
  margin-bottom: 0.2rem;
}

.TxOZ1v6RrtK6SNKSEukb .vertival-box {
  margin-bottom: 0.4rem;
  padding-bottom: 0.48rem;
  position: relative;
}

.bUGFPYZ0IBtUg6TvqFnc {
  display: -ms-flexbox;
  display: flex;
}

.link-list-title {
  color: var(--theme-text-color);

  margin-bottom: 0.2rem;
}

.mmensnemConem {
  position: relative;
  padding-bottom: 0.4rem;
}

.mmensnemConem:after,
.vertival-box:after {
  background-color: var(--theme-color-line);
  bottom: 0;
  content: '';
  height: 0.01rem;
  left: 50%;
  position: absolute;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  width: 100%;
}

.UJY0E549iXw8BAops2og .dIvaBEC9yHdlaEHxlYwe .m4LhLKEZzJw_JjBFp0PP {
  color: var(--theme-text-color);
  cursor: pointer;
  font-size: 0.24rem !important;
  margin-bottom: 0.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.company-info {
  font-size: 0.18rem;
  padding: 0.2rem;
  position: initial;
  text-align: center;
}

.contactus-box {
  margin-bottom: 0.3rem;
}

.dX6cyFScnFIBaOgvBaOs {
  color: var(--theme-text-color-lighten);
  font-size: 0.26rem;
  font-weight: 400;
  margin-bottom: 0.2rem;
}

.ZRKW0CIFYaJACLzrm8Rh {
  box-sizing: border-box;
  height: 0.7rem;
  display: flex;
}

.license-compliance {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

.M5NoRqtHOQuocfpNLEaP {
  -ms-flex-align: center;
  align-items: center;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  box-sizing: border-box;
  gap: 0.2rem;
}

.TNhhMltbvlGJmWgLd9F5 {
  -ms-flex-pack: center;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  gap: 0.1rem;
  justify-content: center;
  margin-top: 0.4rem;
}

.copy-right {
  padding-top: 0;
}

/* .ZvyDsn48oSuCoga63jmJ ul {
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    width: 100%
} */
.ZvyDsn48oSuCoga63jmJ {
  -ms-flex-pack: center;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  width: 100%;
}

.ZvyDsn48oSuCoga63jmJ ul {
  -ms-flex-pack: center;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  margin: 0 !important;
  width: 100%;
}

.ZvyDsn48oSuCoga63jmJ ul li {
  border-right: 0.01rem solid var(--theme-color-line);
  color: var(--theme-text-color-lighten);
  font-size: 0.16rem;
  line-height: 1.2;
  overflow: hidden;
  padding: 0 0.32rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ZvyDsn48oSuCoga63jmJ ul li:last-child {
  border-right: 0;
}

.svg-icon_pmd {
  position: absolute;
  left: 0;
}

.N4LsWhJBhqqyTkv6V0NE {
}

/* 精灵图字体样式 */
.sprite-font {
  display: inline-block;
  height: 0.83rem;
  vertical-align: top;
  background-repeat: no-repeat;
  background-size: auto 100%;
}

/* 数字字符样式 - 如果需要固定位置的话可以使用这些类 */
.sprite-char-0 {
  background-position: 0 0;
  width: 0.5rem;
}

.sprite-char-1 {
  background-position: -0.5rem 0;
  width: 0.5rem;
}

.sprite-char-2 {
  background-position: -1rem 0;
  width: 0.5rem;
}

.sprite-char-3 {
  background-position: -1.5rem 0;
  width: 0.5rem;
}

.sprite-char-4 {
  background-position: -2rem 0;
  width: 0.5rem;
}

.sprite-char-5 {
  background-position: -2.5rem 0;
  width: 0.5rem;
}

.sprite-char-6 {
  background-position: -3rem 0;
  width: 0.5rem;
}

.sprite-char-7 {
  background-position: -3.5rem 0;
  width: 0.5rem;
}

.sprite-char-8 {
  background-position: -4rem 0;
  width: 0.5rem;
}

.sprite-char-9 {
  background-position: -4.5rem 0;
  width: 0.5rem;
}

.sprite-char-dot,
.sprite-char-\. {
  background-position: -5rem 0;
  width: 0.3rem;
}

/* .sprite-char-comma,
.sprite-char-\, {
  background-position: -5.3rem 0;
  width: 0.3rem;
} */

/* Sidebar滚动隐藏效果 */
.sidebar-hidden {
  transform: translateX(60%) !important;
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out !important;
}
.sidebaLeft-hidden {
  transform: translateX(-60%) !important;
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out !important;
}

/* 确保sidebars组件有过渡效果 */
sidebars {
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
}

._marketing-title_1k0qx_129 {
  position: absolute;
  bottom: 0;
  left: 50%;
  max-width: 100%;
  transform: translate(-50%);
  box-shadow: inset 0 0 0 0.01rem rgba(255, 255, 255, 0.3);
  border-radius: 0.18rem;
  color: #fff;
  font-size: 0.2rem;
  padding: 0 0.1rem;
  height: 0.3rem;
  line-height: 0.3rem;
  z-index: 1;
  margin-bottom: 0.25rem;
}

/* 确保 van-grid-item 有相对定位，为绝对定位的标题提供定位上下文 */
:deep(.van-grid-item) {
  position: relative;
}
</style>
s
